import { app } from "./flamelink";
import store from "@store";

export const globals = () => {
  const { fetching, available } = store.state.io.global;

  if (!fetching && !available) {
    store.commit("global/fetching", true);

    app.content.get({ schemaKey: "global", populate: true }).then(data => {
      Object.entries(data).forEach(async ([key, value]) =>
        store.dispatch("global/addData", { key, value })
      );

      store.commit("global/fetching", false);
      store.commit("global/available", true);
    });
  }

  return store.getters["global/data"];
};
